import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ConfigProvider } from "antd";
import { useThemeMode } from "../contexts/ThemeContext";
import { getAppAntdTheme } from "../theme/antdTheme";

/**
 * Auth pages (sign-in, sign-up, etc.) always render in light mode.
 * The user's saved theme from their account is applied after login via UserThemeSync.
 */
export default function AuthLayout() {
  const { themeMode } = useThemeMode();

  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("auth-theme-locked");
    html.setAttribute("data-bs-theme", "light");

    return () => {
      html.classList.remove("auth-theme-locked");
      html.setAttribute("data-bs-theme", themeMode);
    };
  }, [themeMode]);

  return (
    <ConfigProvider theme={getAppAntdTheme("light")}>
      <Outlet />
    </ConfigProvider>
  );
}
